import React from "react";
import { Link } from "react-router-dom";

export function SplitEditorial() {
  return (
    <section className="w-full">
      <div className="flex flex-col md:flex-row w-full h-auto md:h-[70vh]">
        {/* Women's Edit */}
        <div className="relative w-full md:w-1/2 h-[60vh] md:h-full group overflow-hidden">
          <img
            src="/images/campaign/split_women.png"
            alt="Women's Summer Edit"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-500" />
          <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-16">
            <h3 className="font-display text-display-md text-white font-light mb-2">
              Women's Summer Edit
            </h3>
            <p className="text-white/80 font-light mb-6 text-sm md:text-base">
              "Lightness, defined."
            </p>
            <div>
              <Link to="/women" className="btn-fashion btn-fashion-white">
                EXPLORE WOMEN
              </Link>
            </div>
          </div>
        </div>

        {/* Men's Edit */}
        <div className="relative w-full md:w-1/2 h-[60vh] md:h-full group overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1598808503746-f34c53b9323e?w=900&h=1200&fit=crop&q=85"
            alt="Men's Modern Tailoring"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-500" />
          <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-16">
            <h3 className="font-display text-display-md text-white font-light mb-2">
              Men's Modern Tailoring
            </h3>
            <p className="text-white/80 font-light mb-6 text-sm md:text-base">
              "Precision without effort."
            </p>
            <div>
              <Link to="/men" className="btn-fashion btn-fashion-white">
                EXPLORE MEN
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
